<template>
  <div class="cInputAge-container">
    <cInputTitle :text="title"></cInputTitle>
    <section class="cInputAge-main">
      <div class="item-brith-content">
        <cNumInput
          placeholder="西暦"
          :value.sync="year"
          @input="
            (value) => {
              handleInputyear(value);
            }
          "
          :formatError="formatError"
          oninput="value = value.replace(/[^\d０-９]/g, ''); if (value.length > 4) value = value.slice(0, 4)"
          class="brith-year"
        ></cNumInput>
        <span class="label">年</span>
        <cNumInput
          placeholder=""
          :value.sync="month"
          :formatError="formatError"
          oninput="value = value.replace(/[^\d０-９]/g, ''); if (value.length > 2) value = value.slice(0, 2)"
          class="brith-month"
          @input="
            (value) => {
              handleInputmonth(value);
            }
          "
        ></cNumInput>
        <span class="label">月</span>
        <cNumInput
          placeholder=""
          :value.sync="day"
          :formatError="formatError"
          oninput="value = value.replace(/[^\d０-９]/g, ''); if (value.length > 2) value = value.slice(0, 2)"
          class="brith-month"
          @input="
            (value) => {
              handleInputday(value);
            }
          "
        ></cNumInput>
        <span class="label">日</span>
        <p class="brith-msg" v-show="formatError">{{ msg ? msg : birthMsg }}</p>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  props: ['title', 'year', 'month', 'day', 'formatError', 'msg'],
  data() {
    return {
      birthMsg: '日付を正しく入力してください。'
    };
  },
  created() {
    this.cyear = this.year;
  },
  computed: {
    date() {
      if (this.year != '' && this.month != '' && this.day != '') {
        var month = this.commonJs.fillTime(this.month);
        var day = this.commonJs.fillTime(this.day);
        return this.year + '-' + month + '-' + day;
      }
      return false;
    }
  },
  watch: {
    date(val) {
      let status = false;
      if (val) {
        status = !this.commonData.birthreg.test(val);
        this.$emit('changeError', status);
        if (!status) {
          status = !this.commonJs.verifyDetaMAxToday(val);
          this.$emit('changeError', status);
          return;
        }
      } else {
        return this.$emit('changeError', true);
      }
    }
  },
  methods: {
    handleInputyear(value) {
      this.$emit('changeInput', value, 1);
    },
    handleInputmonth(value) {
      this.$emit('changeInput', value, 2);
    },
    handleInputday(value) {
      this.$emit('changeInput', value, 3);
    }
  }
};
</script>

<style lang="less" scoped>
.cInputAge-container {
  .cInputAge-main {
    margin-bottom: 0.27rem;
    .item-brith-content {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      max-width: 3.75rem;
      .brith-year {
        width: 1.1rem;
      }
      .brith-month {
        width: 0.55rem;
      }
      .label {
        font-size: 0.16rem;
        color: #333333;
        margin: 0 0.1rem;
        font-weight: 500;
      }
      .label:last-child {
        margin: 0 0 0 0.1rem;
      }
      .brith-msg {
        position: absolute;
        bottom: -0.18rem;
        left: 0;
        padding: 0 0.05rem;
        color: red;
        font-size: 0.12rem;
        line-height: 0.14rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Input/cInputAge.vue